<template>
<div>
  <div class="item-img" :style="info.thumb | bgImageUrl('/static/peopleCenter/item.png')"/>
  <div class="content">
    <div class="top">{{ info.title }}</div>
    <div class="bottom">
      <div class="bottom-name">
        <img class="avatar" :src="info.avatar | imageUrl('/static/peopleCenter/itemH.png',40,40)"/>
        {{ info.nickName }}
      </div>
    </div>
  </div>
</div>
</template>

<script>
export default {
  props: {
    info: {
      type: Object,
      default: {
        avatar: "",
        nickName: "大薯条",
        thumb: "",
        title: '视频名称',
        url: "",
        userId: 0,
        videoId: 0
      }
    }
  }
};
</script>

<style lang="stylus" scoped>
.content {
  padding: 0 0.2rem;
  color: #333333;

  .top {
    font-size: 0.22rem;
    font-weight: bold;
    margin-top: 0.16rem;
  }

  .center {
    color: #777777;
    margin-top: 0.06rem;
    font-size: 0.14rem;
  }

  .bottom {
    display: flex;
    border-top: 1px solid #F4F4F4;
    justify-content: space-between;
    line-height: 0.55rem;
    margin-top: 0.2rem;

    .avatar {
      /* display block */
      width: 0.26rem;
      height: 0.26rem;
    }
  }
}

.item-img {
  /* width 3.56rem */
  position: relative;
  height: 2.02rem;
  background: url('/static/peopleCenter/item.png') no-repeat;
  background-size: cover;
}

.pointer {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/activity/VideoCreation.vue